// Delete Group
export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
export const DELETE_GROUP_DONE = 'DELETE_GROUP_DONE';
export const DELETE_GROUP_FAILED = 'DELETE_GROUP_FAILED';
